export default __webpack_public_path__ + "static/media/Virgin.03d92191.png";